import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { SERVICE_TYPES } from "@/lib/format";

export const EMPTY_SERVICE = { name: "", description: "", price: "", duration_minutes: 60, service_type: "At your place", active: true };

export function ServiceFields({ value, onChange, idPrefix = "service" }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <Label>Service name</Label>
        <Input data-testid={`${idPrefix}-name-input`} value={value.name} onChange={set("name")} placeholder="e.g. Standard Home Cleaning" className="mt-1.5 h-11" />
      </div>
      <div className="sm:col-span-2">
        <Label>Description</Label>
        <Textarea data-testid={`${idPrefix}-description-input`} value={value.description} onChange={set("description")} rows={2} className="mt-1.5" />
      </div>
      <div>
        <Label>Price (NZD)</Label>
        <Input data-testid={`${idPrefix}-price-input`} type="number" min="0" value={value.price} onChange={set("price")} className="mt-1.5 h-11" />
      </div>
      <div>
        <Label>Duration (minutes)</Label>
        <Input data-testid={`${idPrefix}-duration-input`} type="number" min="15" step="15" value={value.duration_minutes} onChange={set("duration_minutes")} className="mt-1.5 h-11" />
      </div>
      <div className="sm:col-span-2">
        <Label>Service type</Label>
        <select data-testid={`${idPrefix}-type-select`} value={value.service_type} onChange={set("service_type")} className="mt-1.5 h-11 w-full rounded-md border border-input bg-white px-3 text-sm">
          {SERVICE_TYPES.map((t) => <option key={t}>{t}</option>)}
        </select>
      </div>
    </div>
  );
}

export const toServicePayload = (s) => ({ ...s, price: Number(s.price), duration_minutes: Number(s.duration_minutes) });

export default function ServiceDialog({ open, onOpenChange, initial, onSave }) {
  const [value, setValue] = useState(EMPTY_SERVICE);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setValue(initial || EMPTY_SERVICE); }, [open, initial]);
  const save = async () => {
    setBusy(true);
    try { await onSave(toServicePayload(value)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="service-dialog">
        <DialogHeader><DialogTitle className="font-heading">{initial ? "Edit service" : "Add a service"}</DialogTitle></DialogHeader>
        <ServiceFields value={value} onChange={setValue} />
        <Button data-testid="service-save-button" onClick={save} disabled={busy} className="mt-2 h-11 rounded-xl bg-sky-600 hover:bg-sky-700">
          {busy ? "Saving..." : "Save service"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
